<div class="statistics-graph-container">
  <div class="header-container">
    <div class="title-edit-button-container" [ngClass]="{'isClose' : !isContainerExpanded}">
      <ng-container *ngIf="graphAndMapContainerHeaderIcon">
        <nb-icon [icon]="graphAndMapContainerHeaderIcon" pack="icomoon"></nb-icon>
      </ng-container>
      <h1>{{ graphAndMapContainerTitle | t }}<span *ngIf="graphAndMapContainerTotalElements">: {{graphAndMapContainerTotalElements}}</span></h1>
      <div class="edit-menu-container" *ngIf="graphFilterOptions.length > 0 && graphFilterOptions.length !== 1">
        <div
          class="edit-graph-data-container"
          *ngIf="isContainerExpanded && currentActiveMode === 'graph'"
          (click)="toggleSelectDataMenu()"
          [ngClass]="{ 'button-hidden' : isSelectMenuOpen }">
          <nb-icon icon="edit" pack="icomoon"></nb-icon>
        </div>

        <app-select-data-menu
          *ngIf="isSelectMenuOpen"
          [resetFilters]="resetFilters"
          [filterOptions]="graphFilterOptions"
          (isMenuClosed)="closeMenu($event)"
          (currentSelectedFilters)="setSelectedData($event)"></app-select-data-menu>
      </div>
    </div>
    <div class="graph-legend-container" *ngIf="isContainerExpanded && currentActiveMode === 'graph'">
      <app-graph-legend [currentSelectedData]="currentSelectedData" [compareMode]="compareMode"></app-graph-legend>
    </div>
    <div class="buttons-container" [ngClass]="{'noMargin': !isContainerExpanded}">
      <app-mode-switch
        [ngClass]="{'hidden' : section === 'countries' || section ==='referrals' || !isContainerExpanded}"
        class="switch-container"
        [section]="section"
        [switchButtons]="switchButtons"
        (currentSwitchState)="currentActiveMode = $event">
      </app-mode-switch>
      <div [ngClass]="isContainerExpanded ? 'expanded' : ''" class="toggle-button-container">
        <div class="button-inner-container global-transition">
          <button class="expand-collapse-btn" (click)="toggleContainer()">
            {{ (isContainerExpanded ? 'view_translations.collapse' : 'view_translations.expand') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="content-container" *ngIf="isContainerExpanded">
    <app-loader [minHeight]="300" *ngIf=" currentActiveMode === 'graph' && isGraphDataLoading"></app-loader>
    <app-loader [minHeight]="500" *ngIf=" currentActiveMode === 'map' && isMapDataLoading"></app-loader>
    <div class="linear-graph-container" *ngIf=" currentActiveMode === 'graph' && !isGraphDataLoading">
      <app-statistics-linear-graph-v3
        [currentSelectedData]="currentSelectedData"
        [data]="graphData"
        [chartLabels]="graphLabels"
        [userCurrency]="userCurrency"
        [compareMode]="compareMode"
        [compareDates]="compareDates"></app-statistics-linear-graph-v3>
    </div>
    <div class="maps-graph-container" *ngIf=" currentActiveMode === 'map' && !isMapDataLoading" id="maps-graph-container">
      <app-statistics-maps-graph [compareMode]="compareMode" [mapData]="mapData" [mapCompareData]="mapCompareData"></app-statistics-maps-graph>
    </div>
  </div>
</div>
